<script>
import useSharedData from "@/use/SharedData";
import {onMounted, ref} from "vue";
import useSharedMethod from "@/use/SharedMethod";
import useTools from "@/use/Tools";
import {useClasseStore} from "@/stores/Grille/Classe";
import {useSecurityStore} from "@/stores/Security";
import axios from "axios";

export default {
    setup() {
        const {
            total,
            loading,
        } = useSharedData();
        const sheet = ref(true);
        const {rowColor, itemClick, getBack, priceFormat} = useSharedMethod();
        const {$router, $i18n} = useTools();
        const classeStore = useClasseStore();
        const securityStore = useSecurityStore();

        const headers = [
            {
                text: "...",
                align: "start",
                sortable: false,
                value: "action",
                width: "0%",
            },
            {
                text: $i18n.t("common.name"),
                align: "start",
                sortable: false,
                value: "name",
                width: "0%",
            },
            {
                text: $i18n.t("common.periodicity"),
                align: "start",
                sortable: false,
                value: "periodicity",
                width: "0%",
            },
            {
                text: $i18n.t("classe.value"),
                align: "start",
                sortable: false,
                value: "value",
                width: "0%",
            },
            {
                text: $i18n.t("common.percent"),
                align: "start",
                sortable: false,
                value: "percenatge",
            },
        ]

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_GRILLE'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'classes.edit', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_GRILLE'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'classes.delete', params: {id: item.id}})
                },
            }
        ];

        function findAll() {
            loading.value = true;
            axios.get('/classes').then((response) => {
                total.value = response.data.length;
                classeStore.setClasses(response.data);
            }).finally(() => {
                loading.value = false;
            });
        }

        onMounted(() => findAll());

        function view(item) {
            $router.push({name: "classes.view", params: {id: item.id}});
        }

        return {
            classeStore,
            securityStore,
            headers,
            actions,
            total,
            loading,
            sheet,
            rowColor,
            itemClick,
            getBack,
            view,
            findAll,
            priceFormat
        };
    }
};
</script>

<template>
    <div>
        <v-bottom-sheet
                v-model="sheet"
                inset
                persistent
                scrollable
        >
            <v-card elevation="5">
                <w-app
                    :title="$t('module.classes')"
                    show-total
                    :total="total"
                >
                    <template v-slot:rightToolbar>
                        <w-btn-reload
                            :loading="loading"
                            @press="findAll"
                        />
                        <w-btn-add
                            :show="securityStore.authorities['UPDATE_GRILLE']"
                            @press="$router.push({ name: 'classes.add' })"
                        />
                        <w-btn-close @press="getBack"/>
                    </template>

                    <template v-slot:content>
                        <w-data-table
                            :headers="headers"
                            :actions="actions"
                            :items="classeStore.classes"
                            disable-pagination
                            fixed-header
                            height="600"
                            @rowDbClick="view"
                        >
                            <template v-slot:[`item.name`]="{ item }">
                                <w-inline-text bold :text="item.name"/>
                            </template>
                            <template v-slot:[`item.periodicity`]="{ item }">
                                <w-chip
                                    v-if="item.byRung"
                                    outlined
                                    :text="item.periodicity"
                                />
                            </template>
                            <template v-slot:[`item.value`]="{ item }">
                                <w-chip
                                    v-if="item.byValue"
                                    outlined
                                    :text="item.value"
                                />
                            </template>
                            <template v-slot:[`item.percenatge`]="{ item }">
                                <w-chip
                                    v-if="item.byRung && !item.byValue"
                                    outlined
                                    :text="item.percenatge"
                                />
                            </template>
                        </w-data-table>
                    </template>
                </w-app>
            </v-card>
        </v-bottom-sheet>
        <router-view/>
    </div>
</template>
